import { Content } from "@/services/content/types";
import { ARTICLE_TYPES } from "@/services/content/utils";
import * as ArticleTeaser from "./article";
import * as ChronicleTeaser from "./chronicle";
import * as InterviewTeaser from "./interview";
import * as PlayTeaser from "./play";
import * as PodcastTeaser from "./podcast";
import * as PodcastShowTeaser from "./podcast-show";

type MediumProps = {
  item: Content.Entry;
  hideCategory?: boolean;
  hideImage?: boolean;
  component?: string;
  showLinkedContent?: boolean;
  fullWidth?: boolean;
  hideDownPull?: boolean;
};

const Medium = (props: MediumProps) => {
  if (
    props.item.sys.contentType.sys.id === "play" ||
    props.item.sys.contentType.sys.id === "play-episode"
  ) {
    return (
      <PlayTeaser.medium
        play={props.item}
        hideCategory={props.hideCategory}
        showLinkedContent={props.showLinkedContent}
        hideDownPull={props.hideDownPull}
      />
    );
  }

  if (props.item.sys.contentType.sys.id === "podcast-episode") {
    return (
      <PodcastTeaser.medium
        podcast={props.item}
        hideDownPull={props.hideDownPull}
      />
    );
  }

  if (
    props.item.sys.contentType.sys.id === "article" ||
    props.item.sys.contentType.sys.id === "externalContent"
  ) {
    const type = (props.item as Content.Article).fields.type;

    if (type === ARTICLE_TYPES.CHRONICLE) {
      return (
        <ChronicleTeaser.medium
          article={props.item}
          hideImage={props.hideImage}
          hideDownPull={props.hideDownPull}
        />
      );
    }

    if (type === ARTICLE_TYPES.INTERVIEW || type === ARTICLE_TYPES.REPORTAGE) {
      return (
        <InterviewTeaser.medium
          article={props.item}
          component={props.component}
          fullWidth={props.fullWidth}
          showLinkedContent={props.showLinkedContent}
          hideDownPull={props.hideDownPull}
        />
      );
    }

    if (type === ARTICLE_TYPES.ANALYSIS || type === ARTICLE_TYPES.COMMENT) {
      return (
        <ArticleTeaser.medium
          article={props.item}
          hideCategory={props.hideCategory}
          hideImage={props.hideImage}
          showLinkedContent={props.showLinkedContent}
          hideDownPull={props.hideDownPull}
        />
      );
    }

    return (
      <ArticleTeaser.medium
        article={props.item}
        hideCategory={props.hideCategory}
        hideImage={props.hideImage}
        showLinkedContent={props.showLinkedContent}
        hideDownPull={props.hideDownPull}
      />
    );
  }

  if (props.item.sys.contentType.sys.id == "podcast-show") {
    return <PodcastShowTeaser.medium show={props.item} />;
  }

  return null;
};

export default Medium;
